import React, { memo, useState, useEffect } from 'react';

import ReactTable from 'components/ReactTable/ReactTable.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import Button from 'components/CustomButtons/Button';
import { Edit } from '@material-ui/icons';
import { wsCreate } from 'services/WService';
import { useModal } from 'hooks/useModal';
import { TextField } from '@material-ui/core';
import Modal from 'components/Tvendo/Common/ModalBase';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'Cód. proveedor', accessor: 'CardCode', width: 150 },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Nombre categoría', accessor: 'category' },
  { Header: 'Nombre familia', accessor: 'family', width: 250 },
  { Header: 'Cód. Producto', accessor: 'ItemCode', width: 150 },
  { Header: 'Nombre Producto', accessor: 'ItemName' },
  { Header: 'Cód. Almacén', accessor: 'WhsCode', width: 150, align: 'center' },
  { Header: 'Nombre Almacén', accessor: 'WhsName' },
  { Header: 'AvgPrice', accessor: 'AvgPrice', width: 100 },
  { Header: 'Valorizado', accessor: 'Valorizado', width: 100 },
  { Header: 'Stock', accessor: 'stock', width: 110, align: 'right' },
  { Header: 'Stk Compro.', accessor: 'committedStock', width: 130, align: 'right' },
  { Header: 'Stk pedido', accessor: 'StockReceive', width: 130, align: 'right' },
  { Header: 'Stk mínimo', accessor: 'minimunStock', width: 130, align: 'right' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const columnsInvalid = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Cód. Producto', accessor: 'ItemCode', width: 130 },
  { Header: 'Nombre Producto', accessor: 'ItemName' },
  { Header: 'Cód. Almacén', accessor: 'WhsCode', width: 130, align: 'center' },
  { Header: 'Nombre Almacén', accessor: 'WhsName' },
  { Header: 'Stock', accessor: 'OnHand', width: 130, align: 'right' },
  { Header: 'Comprometido', accessor: 'IsCommited', width: 140, align: 'right' },
  { Header: 'Unid. Compro.', accessor: 'orders_commited_units', width: 140, align: 'right' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const AvgPriceModal = memo(function (props) {
  const { model, setOpen } = props;
  const [AvgPrice, setAvgPrice] = useState(0);
  const [processing, setProcessing] = useState(false);

  async function updateAvgPrice() {
    setProcessing(true);
    let res = await wsCreate('logi/stock-revaluation', {
      WhsCode: model?.WhsCode,
      ItemCode: model?.ItemCode,
      AvgPrice,
    });
    setProcessing(false);
    if (res.success) {
      setOpen({ open: false });
      window.alert(res.message);
    } else {
      window.alert(res.message);
    }
  }

  useEffect(() => {
    if (model.open === true) {
      setAvgPrice(parseFloat(model.AvgPrice));
    }
  }, [model]);

  return (
    <Modal
      model={model}
      setOpen={setOpen}
      title="Actualizar AvgPrice 0"
      disabledSave={processing}
      onSubmit={() => {
        updateAvgPrice();
        throw new Error('');
      }}
    >
      {model.WhsCode !== undefined && (
        <>
          <h4>
            Almacén: ({model.WhsCode}) {model.WhsName}
          </h4>
          <h4>
            Producto: ({model.ItemCode}) {model.ItemName}
          </h4>
          <TextField
            label="AvgPrice"
            value={AvgPrice}
            inputProps={{ min: 0.01, step: 0.01 }}
            type="number"
            onChange={(e) => {
              let value = e.target.value;
              if (value == '') value = 0;
              else value = parseFloat(value);
              setAvgPrice(value);
            }}
          />
        </>
      )}
    </Modal>
  );
});

const DataStock = (data) => {
  const [avgPriceModel, setOpen] = useModal();
  return (
    <>
      <AvgPriceModal model={avgPriceModel} setOpen={setOpen} />
      <ReactTable
        excelName="Stock"
        defaultWidth={2400}
        columns={columns}
        data={data.map((stock, i) => {
          return {
            num: (
              <>
                {i + 1}
                <AllowedGuard permission={ConstantPermissions.LOGI_STOCKS_REVALUATE}>
                  <Button
                    justIcon
                    round
                    color="warning"
                    onClick={() => {
                      setOpen(stock);
                    }}
                  >
                    <Edit />
                  </Button>
                </AllowedGuard>
              </>
            ),
            CardCode: stock.CardCode,
            CardName: stock.CardName,
            category: stock.logi_category_description,
            family: stock.logi_family_description,
            ItemCode: stock.ItemCode,
            ItemName: stock.ItemName,
            WhsCode: stock.WhsCode,
            WhsName: stock.WhsName,
            AvgPrice: parseFloat(stock.AvgPrice).toFixed(2),
            Valorizado: parseFloat(stock.AvgPrice) * parseInt(stock.OnHand),
            stock: stock.OnHand,
            committedStock: stock.IsCommited,
            StockReceive: stock.OnOrder,
            minimunStock: stock.MinStock,
            actions: '',
          };
        })}
      />
    </>
  );
};

const DataStockInvalid = (data) => {
  return (
    <ReactTable
      excelName="Stock"
      defaultWidth={1200}
      columns={columnsInvalid}
      data={data.map((stock, i) => {
        return {
          num: i + 1,
          ItemCode: stock.ItemCode,
          ItemName: stock.ItemName,
          WhsCode: stock.WhsCode,
          WhsName: stock.WhsName,
          OnHand: parseInt(stock.OnHand || 0),
          IsCommited: parseInt(stock.IsCommited || 0),
          orders_commited_units: parseInt(stock.orders_commited_units || 0),
          actions: '',
        };
      })}
    />
  );
};

export { DataStock, DataStockInvalid };
